<!--
 * @Author: lijiabing111 1262770419@qq.com
 * @Date: 2023-12-19 15:07:42
 * @LastEditors: lijiabing111 1262770419@qq.com
 * @LastEditTime: 2024-01-26 15:28:11
 * @FilePath: \officialWebsite_front\src\views\news.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="infinite-list-wrapper home" v-loading="vloading">
    <!-- bannar+标语 -->
    <div class="bannar">
      <div class="bigtitle">
        <p class="bannerdes1">新闻资讯</p>
        <p class="bannerdes2">News and information</p>
        <div class="bannaerline"></div>
        <p class="bannerdes3">通过媒体，了解我们更多</p>
      </div>
    </div>
    <div :class="tabStyle == 1 ? 'tap' : 'tap newsmTab2 tabMove'">
      <div
        v-for="item in tabData"
        @click="changeTitle(item)"
        :key="item.id"
        :class="
          active == item.id || keyPath == 5 + '-' + item.id
            ? 'active tapItem'
            : 'tapItem'
        "
      >
        <div>{{ item.dictValue }}</div>

        <div class="tapItemChildren" v-if="item.children">
          <div
            v-for="itemChi in item.children"
            :key="itemChi.id"
            @click="changeTitleChildren(itemChi)"
            :class="
              activeChildren == itemChi.id
                ? 'active tapItemChildrenItem'
                : 'tapItemChildrenItem'
            "
          >
            <div>
              {{ itemChi.dictValue }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="tabContain"
      style="width: 100%; overflow: hidden; display: flex; margin-top: 24px"
    >
      <div
        :class="keyPath == '5-2' ? 'tabContainItem' : 'tabContainItem trans'"
        id="videoContain"
        style="width: 100%; flex-shrink: 0"
      >
        <div
          v-for="videoItem in videoListArray"
          :key="videoItem.value"
          class="videoList"
        >
          <div class="model2title">
            <i :class="videoItem.className"></i>
            <!-- <Minetitle2
              :title1="titleArr[0].title1"
              :title2="titleArr[0].title2"
            /> -->
            <Minetitle2 :title1="videoItem.title" />
          </div>

          <el-carousel
            :interval="3000"
            :autoplay="false"
            class="videoAll"
            height="450px"
            arrow="always"
            indicator-position="none"
            v-if="videoItem.children.length > 0"
          >
            <el-carousel-item
              v-for="item in videoItem.children"
              :key="item.id"
              class="video_item"
            >
              <div class="video_floor1">
                <video class="video_url" :src="item.coverImg"></video>
                <img
                  src="../../public/img/home/play.png"
                  alt=""
                  class="btn_playVideo"
                  @click="openVideo(item.coverImg)"
                />
              </div>
              <div class="video_floor2 clearfix" @click="gotoDetail(item.id)">
                <el-tooltip class="item" effect="dark" placement="top">
                  <div class="video_name">{{ item.title }}</div>
                </el-tooltip>

                <div class="video_time">
                  发布时间：{{ item.uploadTime.slice(0, 10) }}
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="loadingList" v-else>暂无数据</div>
        </div>

        <div class="footer">
          <div class="footerMain clearfix">
            <img class="lf" :src="picUrl + '/img/home/twoCode.png'" alt="" />
            <a class="banben" href="https://beian.miit.gov.cn/" target="_blank"
              >浙ICP备19020141号-1</a
            >
            <div class="rt">
              <ul class="navul clearfix">
                <li>
                  <p class="title" @click="goto(2, 1)">关于大蔚</p>
                  <p class="te" @click="goto(2, 1)">公司简介</p>
                  <p class="te" @click="goto(2, 2)">团队风采</p>
                  <p class="te" @click="goto(2, 3)">公司荣誉</p>
                  <p class="te" @click="goto(2, 4)">企业文化</p>
                  <p class="te" @click="goto(2, 5)">大事记</p>
                  <p class="te" @click="goto(2, 6)">团队风采</p>
                </li>
                <li>
                  <p class="title" @click="goto(3, 1)">解决方案</p>
                  <p class="te" @click="goto(3, 1)">前端分类</p>
                  <p class="te" @click="goto(3, 2)">易腐处理</p>
                  <p class="te" @click="goto(3, 3)">资源利用</p>
                  <p class="te" @click="goto(3, 4)">数字赋能</p>
                </li>
                <li>
                  <p class="title" @click="goto(4, 1)">项目案例</p>
                  <p class="te" @click="goto(4, 1)">前端分类案例</p>
                  <p class="te" @click="goto(4, 2)">易腐处理案例</p>
                  <p class="te" @click="goto(4, 3)">资源利用案例</p>
                  <p class="te" @click="goto(4, 4)">数字赋能案例</p>
                </li>
                <li>
                  <p class="title" @click="goto(5, 1)">新闻资讯</p>
                  <p class="te" @click="goto(5, 1)">视频中心</p>
                  <p class="te" @click="goto(5, 2)">企业动态</p>
                </li>

                <li @click="goto(6)">
                  <p class="title">联系我们</p>
                  <p class="te">联系方式</p>
                  <p class="te">在线留言</p>
                </li>
                <li @click="goto(7)">
                  <p class="title">人才中心</p>
                  <!-- <p class="te">人才招聘</p> -->
                  <!-- <p class="te">简历投递</p> -->
                </li>
                <li style="margin-right: 0" @click="goto(8)">
                  <p class="title">友情链接</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div
        :class="
          keyPath == '5-3' ? 'tabContainItemCou' : 'tabContainItemCou transCou'
        "
        id="newsContain"
        style="width: 100%; flex-shrink: 0"
      >
        <div class="search">
          <i class="el-icon-search"></i>
          <el-input
            placeholder="请输入标题/关键字"
            v-model="textValue"
            class="input-with-select"
            style="border: none"
            @change="searchChange"
          >
          </el-input>
        </div>
        <div
          v-for="(countryItem, index) in countryList"
          :key="countryItem.value"
          class="countryList"
        >
          <div class="model2title" v-if="countryItem.children.length > 0">
            <i :class="countryItem.className"></i>

            <Minetitle2 :title1="countryItem.title" />
          </div>
          <div v-if="countryItem.children.length > 0" class="newslist_con">
            <ul class="newslist_ul">
              <li
                v-for="item in countryItem.children"
                class="newslist_li clearfix"
                @click="gotoDetail(item.id)"
                :key="item.id"
              >
                <div class="news_cover">
                  <img class="news_coverImg" :src="item.coverImg" alt="" />
                </div>
                <div class="news_main">
                  <div class="news_title hidetxt2">{{ item.title }}</div>
                  <div class="news_des hidetxt3">{{ item.summary }}</div>
                  <div class="news_time">
                    发布时间：{{ item.uploadTime.slice(0, 10) }}
                  </div>
                  <div class="btn_look">
                    查看更多
                    <div class="arrow1"></div>
                    <div class="arrow2"></div>
                  </div>
                </div>
              </li>
            </ul>
            <div
              v-if="loadingList[index] == 'true'"
              @click="loadingListData(countryItem, index)"
              class="loadingList"
              style="cursor: pointer"
            >
              点击加载
            </div>
            <div v-else class="noMore loadingList">没有更多了</div>
          </div>
        </div>
        <div class="footer">
          <div class="footerMain clearfix">
            <img class="lf" :src="picUrl + '/img/home/twoCode.png'" alt="" />
            <a class="banben" href="https://beian.miit.gov.cn/" target="_blank"
              >浙ICP备19020141号-1</a
            >
            <div class="rt">
              <ul class="navul clearfix">
                <li>
                  <p class="title" @click="goto(2, 1)">关于大蔚</p>
                  <p class="te" @click="goto(2, 1)">公司简介</p>
                  <p class="te" @click="goto(2, 2)">团队风采</p>
                  <p class="te" @click="goto(2, 3)">公司荣誉</p>
                  <p class="te" @click="goto(2, 4)">企业文化</p>
                  <p class="te" @click="goto(2, 5)">大事记</p>
                  <p class="te" @click="goto(2, 6)">团队风采</p>
                </li>
                <li>
                  <p class="title" @click="goto(3, 1)">解决方案</p>
                  <p class="te" @click="goto(3, 1)">前端分类</p>
                  <p class="te" @click="goto(3, 2)">易腐处理</p>
                  <p class="te" @click="goto(3, 3)">资源利用</p>
                  <p class="te" @click="goto(3, 4)">数字赋能</p>
                </li>
                <li>
                  <p class="title" @click="goto(4, 1)">项目案例</p>
                  <p class="te" @click="goto(4, 1)">前端分类案例</p>
                  <p class="te" @click="goto(4, 2)">易腐处理案例</p>
                  <p class="te" @click="goto(4, 3)">资源利用案例</p>
                  <p class="te" @click="goto(4, 4)">数字赋能案例</p>
                </li>
                <li>
                  <p class="title" @click="goto(5, 1)">新闻资讯</p>
                  <p class="te" @click="goto(5, 1)">视频中心</p>
                  <p class="te" @click="goto(5, 2)">企业动态</p>
                </li>

                <li @click="goto(6)">
                  <p class="title">联系我们</p>
                  <p class="te">联系方式</p>
                  <p class="te">在线留言</p>
                </li>
                <li @click="goto(7)">
                  <p class="title">人才中心</p>
                  <!-- <p class="te">人才招聘</p> -->
                  <!-- <p class="te">简历投递</p> -->
                </li>
                <li style="margin-right: 0" @click="goto(8)">
                  <p class="title">友情链接</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="smTab" :class="tabStyle == 1 ? 'smTab' : 'smTab2 tabMove'">
      <i class="position_s"></i>
      <el-tabs v-model="activeName" @tab-click="tableclick">
        <el-tab-pane label="视频新闻" name="item0"></el-tab-pane>
        <el-tab-pane label="企业资讯" name="item1"></el-tab-pane>
      </el-tabs>
      <div class="smallLine"></div>
    </div>
    <div :class="tabStyle !== 1 ? 'smTab3' : ''"></div> -->
    <!-- <div class="model model2" id="videoAll">
      <i class="position"></i>
      <div class="model2title">
        <Minetitle2 :title1="titleArr[0].title1" :title2="titleArr[0].title2" />
      </div>
      <el-carousel
        :interval="3000"
        :autoplay="false"
        class="videoAll"
        height="810px"
        arrow="always"
      >
        <el-carousel-item
          v-for="item in videolist"
          :key="item.id"
          class="video_item"
        >
          <div class="video_floor1">
            <video class="video_url" :src="item.coverImg"></video>
            <img
              src="../../public/img/home/play.png"
              alt=""
              class="btn_playVideo"
              @click="openVideo(item.coverImg)"
            />
          </div>
          <div class="video_floor2 clearfix" @click="gotoDetail(item.id)">
            <div class="video_name">{{ item.title }}</div>
            <div class="video_time">
              发布时间：{{ item.uploadTime.slice(0, 10) }}
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <i class="position"></i>
      <div class="model2title">
        <Minetitle2 :title1="titleArr[1].title1" :title2="titleArr[1].title2" />
      </div>
      <ul class="newslist_ul">
        <li
          v-for="item in newsList"
          class="newslist_li clearfix"
          @click="gotoDetail(item.id)"
          :key="item.id"
        >
          <div class="news_cover">
            <img class="news_coverImg" :src="item.coverImg" alt="" />
          </div>
          <div class="news_main">
            <div class="news_title hidetxt2">{{ item.title }}</div>
            <div class="news_des hidetxt3">{{ item.summary }}</div>
            <div class="news_time">
              发布时间：{{ item.uploadTime.slice(0, 10) }}
            </div>
            <div class="btn_look">
              查看更多
              <div class="arrow1"></div>
              <div class="arrow2"></div>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="loadingList" @click="loadingListData" class="loadingList">
        <i class="el-icon-loading"></i>点击加载
      </div>
      <div v-if="noMore" class="noMore">没有更多了</div>
    </div> -->
    <!-- 视频弹框 -->
    <el-dialog
      title="视频"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="closeVideo"
    >
      <video :src="videoUrl" class="mineVideo" controls id="video"></video>
    </el-dialog>
  </div>
</template>

<script>
import Minetitle2 from "../components/minetitle2.vue";
import { getFunc } from "@/api/home";
import { postPv } from "@/api/postPv";
import eventbus from "../../src/components/eventbus.vue";
import { picUrl } from "@/config/env";
// @ is an alias to /src
export default {
  name: "home",
  data() {
    return {
      picUrl: "",
      keyPath: "",
      active: "",
      activeChildren: "",
      tabData: [],
      videoUrl: "",
      dialogVisible: false, //视频界面
      vloading: true,
      tabStyle: 1, //1代表平常样式 2代表悬浮
      activeName: "item0",
      titleArr: [
        { id: 1, title1: "视频新闻", title2: "Video News" },
        { id: 2, title1: "企业资讯", title2: "Corporate news" },
      ],
      videolist: [], //视频新闻
      page: {
        pageNo: 1, //页码
        pageSize: 3,
        loading: false,
        error: false,
        finished: false,
      },
      finishedStatus: true,
      newsList: [], //新闻列表
      loadingList: [],
      noMore: false,

      activeIndex: "1",
      keyPathList: ["5-2", "5-3"],
      videoListArray: [],
      countryList: [],
      current: 1,
      currentKey: "",

      textValue: "", //关键字搜索
    };
  },
  watch: {
    $route(newRoute) {
      let keyPath = newRoute.query.keyPath;
      let haveId = this.keyPathList.findIndex((item) => item == keyPath);
      if (haveId == -1) {
        this.$message.info("暂未开放，敬请期待！");
      } else {
        this.keyPath = newRoute.query.keyPath;
        this.active = keyPath.split("-")[0];
      }

      console.log(newRoute.query.keyPath);
    },
  },
  inject: ["reload"],
  computed: {},
  methods: {
    goto(i, j) {
      let arr = [
        "/home",
        "/aboutus",
        "/solution",
        "/projectcase",
        "/news",
        "/contactus",
        "/joinus",
        "/minelink",
      ];
      //配色判断
      eventbus.$emit("myfn", i);

      this.$router.push(arr[i - 1]);
      window.scroll(0, 0);
      return;
    },
    changeTitle(item) {
      this.active = item.id;
      this.keyPath = 5 + "-" + item.id;
      console.log("....", this.keyPath);
    },
    changeTitleChildren(item) {
      this.activeChildren = item.id;
      let className = "videoItem" + item.id.slice(-3);
      let ele = document.getElementsByClassName(className)[0];
      console.log(ele);
      ele.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    },
    getDict() {
      postPv(
        "https://www.azureflying.com/api/blade-system/dict-biz/child-list?current=1&size=10&parentId=1"
      )
        .then((res) => {
          let result = res.data;
          // let arr = result.filter((item) => {
          //   return item.key == "1";
          // });
          this.tabData = result;
          this.getVideoList();
          this.getCountryList();
        })
        .catch((err) => {});
    },
    // 获取主题视频列表
    getVideoList() {
      const that = this;

      let list = this.tabData;
      if (list.length > 0) {
        let titleArray = list.filter((item) => {
          return item.id == "2";
        });
        titleArray[0].children.map((item2) => {
          let url1 = `/blade-website/web/menu/article/vedio/list`; //视频新闻
          //视频资讯
          getFunc(url1, { type: item2.dictKey })
            .then((res) => {
              if (res.code == 200) {
                const data = res.data;
                that.videoListArray.push({
                  value: item2.dictKey,
                  title: item2.dictValue,
                  children: data,
                  className: "videoItem" + item2.id.slice(-3),
                });
              }
            })
            .catch((err) => {
              this.$message.error("获取视频列表失败");
              //console.log(err);
            });
        });
      }
    },
    // 获取主题企业资讯列表
    getCountryList() {
      const that = this;

      let data = this.tabData;
      if (data.length > 0) {
        let titleArray = data.filter((item) => {
          return item.id == "3";
        });
        titleArray[0].children.map((item2) => {
          let url1 = `/blade-website/web/menu/article/news/list`; //视频新闻
          //视频资讯
          getFunc(url1, { current: 1, size: 3, type: item2.dictKey })
            .then((res) => {
              if (res.code == 200) {
                const data = res.data;
                let loadMore = that.loadingList;
                //判断是否还有数据
                if (data.records.length < data.total) {
                  loadMore.push("true");
                } else {
                  loadMore.push("false");
                }
                that.loadingList = loadMore;
                that.countryList.push({
                  value: item2.dictKey,
                  title: item2.dictValue,
                  children: data.records,
                  className: "videoItem" + item2.id.slice(-3),
                });
              }
            })
            .catch((err) => {
              // this.$message.error("获取企业资讯数据失败2");
              //console.log(err);
            });
        });
      }
    },

    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    tableclick(tab) {
      //锚点跳转
      let index = tab.index;
      //console.log(index);
      //跳转到相应锚点
      document
        .getElementsByClassName("position")
        [index].scrollIntoView({ block: "start", behavior: "smooth" });
    },
    loadingListData(item, index) {
      const that = this;
      let url1 = `/blade-website/web/menu/article/news/list`; //视频新闻
      item.current =
        item.value == this.currentKey
          ? ++item.current
          : item.current
          ? ++item.current
          : 2;
      this.currentKey = item.value;

      //视频资讯
      getFunc(url1, { current: item.current, size: 3, type: item.value })
        .then((res) => {
          if (res.code == 200) {
            const data = res.data;
            // debugger
            let loadMore = that.loadingList;

            let newCountryList = that.countryList;
            //判断是否还有数据
            if (data.records.length == 0) {
              loadMore[index] = "false";
            } else {
              loadMore[index] = "true";
            }
            that.loadingList = loadMore;
            newCountryList.map((newItem) => {
              if (newItem.value == item.value) {
                item.children = item.children.concat(data.records);
                let chiItemArr = [];
                item.children.map((chiItem, index) => {
                  if (chiItemArr.includes(chiItem.id)) {
                    item.children.splice(index, 1);
                  } else {
                    chiItemArr.push(chiItem.id);
                  }
                });
                that.countryList = newCountryList;
              }
            });

            // item.children.concat(data.records);
            // console.log(that.countryList);
          }
        })
        .catch((err) => {});
    },
    handleScroll() {
      //获取滚动时的高度
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let height = document.getElementsByClassName("bannar")[0]
        ? document.getElementsByClassName("bannar")[0].offsetHeight - 80
        : "";
      let height2 = document.getElementsByClassName("videoAll")[0]
        ? document.getElementsByClassName("bannar")[0].offsetHeight
        : "";
      if (scrollTop < height + 50) {
        // //console.log("照常展示");
        this.tabStyle = 1;
      } else {
        this.tabStyle = 2;
      }

      if (scrollTop > height + height2) {
        // //console.log("照常展示");
        this.activeName = "item1";
      } else {
        this.activeName = "item0";
      }

      //底下是滚动加载下一页
      //变量windowHeight是可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
    },

    closeVideo() {
      this.dialogVisible = false;
      this.$nextTick(() => {
        let video = document.getElementById("video");
        video.pause();
      });
    },
    openVideo(url) {
      //打开视频
      let that = this;
      //console.log(url);
      this.videoUrl = url;
      this.dialogVisible = true;
      this.$nextTick(() => {
        let video = document.getElementById("video");
        video.play();
      });
    },
    gotoDetail(id) {
      //详情
      // //console.log(id);
      this.$router.push({
        path: "/newsdetail",
        query: { id: id, keyPath: this.keyPath },
      });
      this.$forceUpdate();
      window.scroll(0, 0);
    },
    onLoad(page = this.page.pageNo, pageSize = this.page.pageSize) {
      let thiz = this;
      let url2 = "/blade-website/web/menu/article/news/list"; //企业资讯
      //如果没有更多 返回不加载了
      // //console.log(thiz.page.finished);
      if (this.page.finished) {
        //走完不走了
        return false;
      }
      getFunc(url2, { current: page, size: pageSize })
        .then((res) => {
          if (res.code == 200) {
            const data2 = res.data.records;
            // //console.log(data2);
            if (data2.length == 0) {
              //加载完了
              thiz.page.finished = true;
              thiz.page.loading = false;
              this.noMore = true;
              setTimeout(() => {
                thiz.finishedStatus = false;
              }, 1500);
            } else {
              this.noMore = false;
              //加一页
              let page = thiz.page.pageNo;
              page++;
              thiz.page.pageNo = page;
              // //console.log(page);
              thiz.newsList = thiz.newsList.concat(data2);
              thiz.page.finished = false;
              thiz.page.loading = true;
            }
          } else {
            thiz.page.finished = true;
            thiz.page.loading = false;
          }
          thiz.vloading = false;
        })
        .catch((err) => {
          thiz.vloading = false;
          thiz.page.finished = true;
          thiz.page.loading = false;
        });
    },
    searchChange() {
      if (this.textValue) {
        let url2 = "/blade-website/web/menu/article/news/list";

        getFunc(url2, { current: 1, size: 10, title: this.textValue }).then(
          (res) => {
            let result = res.data.records;

            if (result.length == 0) {
              this.$message.warning("未查到相关数据！");
            } else {
              result.map((chi) => {
                let chiId = "videoItem" + result[0].parentId.slice(-3);

                let ele = document.getElementsByClassName(chiId)[0];
                ele.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
                this.countryList.map((item) => {
                  if (item.className == chiId) {
                    item.children.unshift(chi);
                  }
                  let chiItemArr = [];
                  item.children.map((chiItem, index) => {
                    if (chiItemArr.includes(chiItem.id)) {
                      item.children.splice(index, 1);
                    } else {
                      chiItemArr.push(chiItem.id);
                    }
                  });
                });
              });
            }
          }
        );
      }
    },
  },
  mounted() {
    let thiz = this;
    this.$nextTick(() => {
      this.picUrl = picUrl;
      this.changeTitle({ id: "3" });
    });
    this.getDict();
    let url1 = "/blade-website/web/menu/article/vedio/list"; //视频新闻
    thiz.$nextTick(() => {
      //企业资讯
      thiz.onLoad();
      //视频资讯
      getFunc(url1)
        .then((res) => {
          if (res.code == 200) {
            const data1 = res.data;
            // //console.log(data1);
            thiz.videolist = data1;
            thiz.vloading = false;
          }
        })
        .catch((err) => {
          thiz.vloading = false;
          //console.log(err);
        });
      window.addEventListener("scroll", this.handleScroll);
      postPv("https://www.azureflying.com/api/blade-website/analytics/access")
        .then((res) => {})
        .catch((err) => {});
      //发送pv
    });
    let keyPath = this.$router.history.current.query.keyPath;

    this.keyPath = keyPath;
    this.active = keyPath.split("-")[0];
  },
  components: { Minetitle2 },
};
</script>
<style scoped>
.home {
  width: 100%;
  overflow-x: hidden;
  padding-top: 80px;
  background: #f7f7f7;
  height: 99%;
  overflow: auto;
}
.bannar {
  width: 100%;
  height: 673px;
  position: relative;
  background: url("../../public/img/bannar_news.jpg") no-repeat;
  background-size: cover;
}
.bannar img {
  width: 100%;
  height: 100%;
}
.bigtitle {
  width: 680px;
  position: absolute;
  left: 320px;
  top: 130px;
}
.bannerdes1 {
  font-size: 76px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #fff;
  line-height: 72px;
  margin-bottom: 48px;
  letter-spacing: 10px;
}
.bannerdes2 {
  font-size: 40px;
  line-height: 40px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #fff;
  margin-bottom: 79px;
  letter-spacing: 3px;
}
.bannaerline {
  width: 68px;
  height: 6px;
  background: #cccccc;
  margin-bottom: 21px;
}
.bannerdes3 {
  width: 100%;
  height: auto;
  line-height: 60px;
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 300;
  color: #fff;
  letter-spacing: 5px;
}

/* 小导航栏 */

.model {
  width: 88%;
  max-width: 1702px;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: column;
}
.model2title {
  /* padding-left: 200px; */
}
.videoAll {
  width: 75%;
  margin: 0 auto;
  height: 450px;
  overflow: hidden;
}
.video_item {
  /* width: 1045px; */
  height: 100%;
}
.video_floor1 {
  /* width: 1038px;*/
  height: 80%;
  /* border: 1px solid #589ef8; */
  box-shadow: -1px 1px 9px 1px rgba(17, 126, 185, 0.68);
  margin-bottom: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.video_url {
  width: 98%;
  height: 98%;
  background: #383838;
  object-fit: fill;
  position: absolute;
  left: 1%;
  top: 1%;
}
.btn_playVideo {
  width: 151px;
  height: 151px;
  position: relative;
  z-index: 25;
}
.video_floor2 {
  width: 100%;
  height: 32px;
}
.video_name {
  height: 32px;
  line-height: 32px;
  font-size: 32px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  float: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70%;
}
.video_time {
  float: right;
  height: 32px;
  line-height: 32px;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}
/* 第一个还有最后一个往中间靠 下面的字隐藏 .el-carousel__container .video_item*/
.video_floor2 {
  display: none;
}
.videoAll .is-active .video_floor2 {
  display: inline-block;
  transition: all 0.5s;
}
.videoAll .is-active {
  width: 88%;
  transform: translateX(7%) !important;
}

/* 新闻列表 */
.newslist_con {
  background: white;
  padding: 24px;
  border-radius: 16px;
  margin-bottom: 55px;
}
.newslist_ul {
  width: 100%;
  position: relative;
  overflow: auto;
}
.newslist_li {
  width: 100%;
  height: 224px;
  margin-bottom: 42px;
  display: flex;
  justify-content: space-between;
}
.newslist_li:hover .news_cover {
  transform: scale(0.98);
  transition: transform 0.2s linear;
}
.newslist_li:hover .news_main {
  transform: translateX(-10px);
  transition: transform 0.2s linear;
}
.newslist_li:hover .news_title {
  color: #589ef8;
  transition: color 0.2s linear;
}
.newslist_li:hover .btn_look {
  color: #589ef8;
  transition: color 0.2s linear;
}

.news_cover {
  height: 100%;
  float: left;
  margin-right: 40;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.news_coverImg {
  height: 100%;
  width: 340px;
}

.news_main {
  width: 66%;
  height: 100%;
  float: right;
}
.news_title {
  width: 100%;
  height: 120px;
  padding-bottom: 15px;
  font-size: 24px;
  line-height: 36px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  margin-bottom: 10px;
  border-bottom: 1px solid #dddddd;
  /* margin-bottom: 40px; */
}
.news_des {
  width: 100%;
  height: 60px;
  font-size: 20px;
  line-height: 30px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  /* margin-bottom: 31px; */
}
.news_time {
  float: left;
  height: 20px;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}
.btn_look {
  float: right;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  padding-right: 40px;
  position: relative;
}
.arrow1 {
  width: 10px;
  height: 2px;
  background: #999999;
  transform: rotate(45deg);
  position: absolute;
  right: 19px;
  top: 12px;
}
.arrow2 {
  width: 10px;
  height: 2px;
  background: #999999;
  transform: rotate(135deg);
  position: absolute;
  right: 19px;
  top: 18px;
}
.mineVideo {
  width: 100%;
  height: 430px;
  /* height:50vw; */
}
.final_li {
  width: 100%;
  text-align: center;
  height: 40px;
  line-height: 40px;
  font-size: 20px;
  margin-bottom: 30px;
}

.position,
.position_s {
  position: relative;
  z-index: -1;
  left: 0%;
  top: -180px;
}
.position_s {
  position: absolute;
  top: -180px;
}
/* #videoAll .videoAll .el-carousel__arrow {
  transform: scale(1.5) !important;
  -webkit-transform: scale(1.5) !important;
} */
.loadingList {
  margin: 0 auto;
  font-size: 24px;
  color: #999999;
  display: flex;
  justify-content: center;
}
.loadingList i {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  color: #589ef8;
}
.tap {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 36px;
  width: 100%;
  border-bottom: 1px solid #999999;
  padding-left: 230px;
  box-shadow: 0px 0px 5px 4px #99999982;
}
.tap .tapItem {
  padding: 8px 16px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  position: relative;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tap .tapItem.active {
  color: #589ef8;
  border-bottom: 2px solid #589ef8;
}
.tap .tapItem:hover {
  border-bottom: 2px solid #589ef8;
  background: rgba(0, 0, 0, 0.1);
}
.tap .tapItem:hover .tapItemChildren {
  opacity: 1;
  transition: all 0.5s;
}
.tap .tapItem .tapItemChildren {
  position: absolute;
  background: white;
  top: 65px;
  width: 100%;
  left: 0;
  opacity: 0;
  transition: all 0.5s;
  z-index: 99;
}
.tap .tapItem .tapItemChildren .tapItemChildrenItem {
  font-size: 20px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 0;
  width: 100%;
}
.tap .tapItem .tapItemChildren .tapItemChildrenItem:hover {
  background: rgba(0, 0, 0, 0.1);
}
.tap .tapItem .tapItemChildrenItem.active {
  color: #589ef8;
}
.tabContainItem {
  transform: translateX(0);
  transition: all 0.5s;
  height: auto;
}
.tabContainItem.trans {
  height: 0;
  transform: translateX(-100%);
  transition: all 0.5s;
}
.tabContainItemCou {
  transform: translateX(-100%);
  transition: all 0.5s;
  height: auto;
  position: relative;
}
.tabContainItemCou.transCou {
  height: 0;
  transform: translateX(0%);
  transition: all 0.5s;
}
.tabContainItem.hidd {
  animation: hiddAni 0.5 linear;
}
@keyframes hiddAni {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  50% {
    opacity: 0.5;
    transform: translateX(-50%);
  }
  100% {
    opacity: 0;
    transform: translateX(-100%);
  }
}
.videoList {
  padding: 14px 0px 14px 0px;
}
.smoothCON {
  height: 270px;
}
.newsmTab2 {
  position: fixed;
  left: 0;
  top: 0.416667rem;
  background: #f9f9f9;
  z-index: 99;
}
.footer {
  background: #f5f5f5;
  padding: 73px 0 40px 0;
}
.footerMain {
  width: 83%;
  max-width: 1600px;
  margin: 0 auto;
  position: relative;
}
.lf {
  width: 450px;
  height: 220px;
  float: left;
}
.rt {
  float: right;
}

@media (max-width: 1024px) {
  .rt {
    display: none;
  }
}
ul,
li {
  list-style: none;
}

.navul li {
  margin-right: 40px;
  float: left;
}

.title {
  font-size: 24px;
  color: #333333;
  font-weight: 400;
  font-family: Source Han Sans CN;
  margin-bottom: 22px;
}
.te {
  font-size: 18px;
  margin-bottom: 13px;
  color: #999;
  transition: all 0.3s;
}
.te:hover {
  color: #409eff;
  cursor: pointer;
}
.banben {
  position: absolute;
  left: 0;
  bottom: 0;
}
.countryList {
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
  width: 66%;
  margin: 0 auto;
}
.search {
  width: 427px;
  height: 56px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  border: 2px solid #d1d1d1;
  display: flex;
  align-items: center;
  padding: 4px 8px;
  position: absolute;
  right: 320px;
  top: 8px;
  z-index: 999;
}
</style>

<style>
.input-with-select .el-input__inner {
  border: none !important;
}
</style>
